import React from 'react'
import styled from 'styled-components'

import { Currency } from '../../sdk'
import CurrencyLogo from '../CurrencyLogo'

/** Solape visual: apenas se tocan (~12% del diámetro, mín. 3px). */
function stackOverlapPx(size: number): number {
  return Math.max(3, Math.round(size * 0.12))
}

const Wrapper = styled.div<{ margin: boolean; sizeraw: number; stackwidth: number }>`
  position: relative;
  display: flex;
  flex-direction: row;
  width: ${({ stackwidth }) => stackwidth}px;
  height: ${({ sizeraw }) => sizeraw}px;
  flex-shrink: 0;
  margin-right: ${({ sizeraw, margin }) => margin && (sizeraw / 3 + 8).toString() + 'px'};
`

const SeparatedWrapper = styled.div<{ margin: boolean; sizeraw: number; gap: number }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ gap }) => gap}px;
  flex-shrink: 0;
  margin-right: ${({ sizeraw, margin }) => margin && (sizeraw / 3 + 8).toString() + 'px'};
`

interface DoubleCurrencyLogoProps {
  margin?: boolean
  size?: number
  currency0?: Currency
  currency1?: Currency
  /** stacked: monedas superpuestas con toque leve. separated: lado a lado. */
  layout?: 'stacked' | 'separated'
  /**
   * Color del anillo que “recorta” el solape (debe coincidir con el fondo del contenedor).
   * Por defecto: card / background de la app.
   */
  ringColor?: string
}

const HigherLogo = styled(CurrencyLogo)`
  z-index: 2;
  position: relative;
`
const CoveredLogo = styled(CurrencyLogo)<{ offset: number }>`
  position: absolute;
  left: ${({ offset }) => offset}px;
  top: 0;
  z-index: 1;
`

const DEFAULT_RING = 'var(--card, var(--background, #12151c))'

export default function DoubleCurrencyLogo({
  currency0,
  currency1,
  size = 16,
  margin = false,
  layout = 'stacked',
  ringColor = DEFAULT_RING,
}: DoubleCurrencyLogoProps) {
  const logoSize = size.toString() + 'px'
  const overlap = stackOverlapPx(size)
  const offset = size - overlap
  const stackWidth = currency1 ? size + offset : size
  const stackRingStyle: React.CSSProperties = {
    boxShadow: `0 0 0 2px ${ringColor}`,
  }

  if (layout === 'separated') {
    return (
      <SeparatedWrapper sizeraw={size} margin={margin} gap={Math.max(6, Math.round(size / 4))}>
        {currency0 ? <CurrencyLogo currency={currency0} size={logoSize} /> : null}
        {currency1 ? <CurrencyLogo currency={currency1} size={logoSize} /> : null}
      </SeparatedWrapper>
    )
  }

  return (
    <Wrapper sizeraw={size} margin={margin} stackwidth={stackWidth}>
      {currency0 && (
        <HigherLogo currency={currency0} size={logoSize} style={stackRingStyle} />
      )}
      {currency1 && (
        <CoveredLogo
          currency={currency1}
          size={logoSize}
          offset={offset}
          style={stackRingStyle}
        />
      )}
    </Wrapper>
  )
}
